"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.scss");
const react_1 = __importDefault(require("react"));
const text_1 = require("../text");
const Radio = ({ children, label, value, className, onClick, disabled, testid, }) => {
    const cN = ['ds-radio'];
    if (value)
        cN.push('is-selected');
    if (disabled)
        cN.push('is-disabled');
    if (className)
        cN.push(className);
    return (react_1.default.createElement("div", { "data-testid": testid, onClick: disabled ? undefined : onClick, className: cN.join(' ') },
        react_1.default.createElement("div", { className: 'ds-radio-el' }),
        children || label ? react_1.default.createElement(text_1.Text, { type: 'body-large' }, children || label) : null));
};
exports.default = Radio;
